import React from 'react';

const Blog: React.FC = () => {
    return (
        <>
      
        </>
    );
}

export default Blog;
